<template>
  <div  v-if="rol_usuario !== '3'">

  
  <div class="w-10/12 mx-auto flex-row flex-wrap justify-between font-costea">
    <div class="flex flex-row justify-between pt-4 pb-2 mb-6 mt-2 border-b-2 flex-wrap">
      <h1 class="font-costea text-h24 font-medium text-costeaBlack mb-4 md:mb-0">
        Gestión de usuarios
      </h1>
      <div class="flex flex-row items-center">
        <p class="text-costeaGray ml-6 mr-3 text-t14">
          <span class="text-costeaBlack font-medium">{{ page }}</span> de <span>{{ getPageNumber() }}</span>
        </p>
        <div class="flex flex-row h-full">
          <button class="w-10 mr-1 bg-costeaBtn2 hover:bg-costeaBtn2Hover text-costeaGray opacity-50"
            @click="page--, getPageNumber()" v-if="page != 1"><i class="ri-arrow-left-line"></i></button>
          <button class="w-10 bg-costeaBtn2 hover:bg-costeaBtn2Hover text-costeaGray" @click="page++, getPageNumber()"
            v-show="page < getPageNumber()"><i class="ri-arrow-right-line"></i></button>
        </div>
      </div>
    </div>


    <div class="grid grid-cols-12 gap-x-5">
      <div class="col-span-full bg-white overflow-auto rounded-md p-6">
        <table class="table-auto border-collapse w-full">
          <thead>
            <tr class="h-10 font-costea text-t14 border-b-2">
              <th class="text-left">
                <span class="px-2 cursor-pointer text-costeaDarkGray">Usuario (email)</span>
              </th>
              <th class="text-left">
                <span class="px-2 cursor-pointer text-costeaDarkGray">Nombres</span>
              </th>
              <th class="text-left">
                <span class="px-2 cursor-pointer text-costeaDarkGray">Apellidos</span>
              </th>
              <th class="text-left">
                <span class="px-2 cursor-pointer text-costeaDarkGray">Rol</span>
              </th>
              <th class="text-left">
                <span class="px-2 cursor-pointer text-costeaDarkGray">Teléfono</span>
              </th>
              <th class="text-left">
                <span class="px-2 cursor-pointer text-costeaDarkGray">Acciones</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in displayedUsers" :key="user.index" class="h-16 font-costea text-t14 border-b">
              <td class="flex flex-row items-center justify-start px-2 flex-wrap">
                <img :src="showImage(user.picture)" :alt="'Foto de perfil' + user.email" class="w-10 rounded-lg">
                <span class="px-2 cursor-pointer text-costeaDarkGray">{{ user.email }}</span>
              </td>
              <td class="text-left px-2">
                <span class="cursor-pointer text-costeaDarkGray">{{ user.name }}</span>
              </td>
              <td class="text-left px-2">
                <span class="cursor-pointer text-costeaDarkGray">{{ user.last_name }}</span>
              </td>

              <td class="text-left px-2">
                <span class="cursor-pointer text-costeaDarkGray">{{ user.role_id }}</span>
              </td>
              <td class="text-left px-2">
                <span class="cursor-pointer text-costeaDarkGray">{{ user.telephone }}</span>
              </td>
              <td class="text-left px-2">
                <span class="cursor-pointer text-costeaDarkGray ml-2" @click="openEditModal(user.id)"><i
                    class="ri-edit-line"></i></span>
                <span class="cursor-pointer text-costeaDarkGray ml-4"
                  v-on:click="toggleModalConfirm(user.id, user.name)"><i class="ri-delete-bin-6-line"></i></span>
                <div v-if="showModalConfirm"
                  class="addmodal fixed w-full h-full z-20 top-0 left-0 flex justify-center items-start">
                  <div class="bg-white m-auto w-96 flex flex-col rounded-md justify-center items-center">
                    <h2
                      class="font-costea w-10/12 px-2 py-1 my-4 mx-auto border-b border-gray-200 text-left text-t20 font-medium text-costeaBlack">
                      Eliminar Usuario
                    </h2>
                    <form class="flex flex-col justify-start w-full items-center">
                      <div class="mb-4 px-2 py-2 flex flex-col content-center items-center w-10/12 rounded-md">
                        <span class="w-full text-costeaGray items-center content-center text-t16 mb-3">Si deseaa eliminar
                          al usuario <span
                            class="uppercase bg-gray-100 tracking-wider text-costeaGray italic p-1 rounded-md text-t14 font-bold">{{ deleteName }}</span>,
                          escriba<span
                            class="uppercase bg-gray-100 tracking-wider text-costeaGray italic p-1 rounded-md text-t14 font-bold">BORRAR</span>
                          para eliminar.</span>
                        <input v-model="confirmDelete" type="text" required
                          class="bg-white font-medium placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-3 text-t16 w-full rounded-md uppercase tracking-wider"
                          placeholder="Aqui va borrar">
                      </div>
                      <div class="mb-4 p-2 flex content-center items-center w-10/12 rounded-md justify-between">
                        <button
                          class="bg-blue-100 rounded-md text-blue-700 hover:bg-blue-200 duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t14 uppercase tracking-wide"
                          v-on:click="toggleModalConfirm(0, null)" type="button">Cancelar</button>
                        <button
                          :class="'rounded-md text-white hover:bg-costeaDarkSalmon hover:text-white duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t14 uppercase tracking-wide bg-blue-500 hover:bg-red-400'"
                          @click="deleteUser(user.id)" type="button">Eliminar</button>
                      </div>
                    </form>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <transition name="fade">
        <component v-show="this.modalAdd" :is="showModalAdd" @closeModalAdd="handleAddCloseModal"
          @reloadData='reloadData' />
      </transition>
      <transition name="fade">
        <component v-show="this.modalEdit" :is="showModalEdit" @closeModalEdit="handleEditCloseModal"
          @reloadData='reloadData' :id="editId" />
      </transition>
      <transition name="fade">
        <component :is="modalDelete" :componenteOld="deleteName" :componenteId="deleteId" v-show="this.modalDelete"
          @closeModalDelete="handleDeleteCloseModal" @reloadData='reloadData' />
      </transition>

      <buttonAdd @showModal="handleAddOpenModal" />

    </div>

  </div>
</div>
</template>

<script>
import buttonAdd from '@/components/elements/ButtonAdd.vue'
import componentAdd from '@/components/userManagement/AddUsers.vue'
import componentEdit from '@/components/userManagement/EditUser.vue'
import componentDelete from '@/components/componentes/DeleteComponents.vue'
import { mapState } from 'vuex'
import axios from 'axios'
export default {
  components: {
    buttonAdd,
    componentAdd,
    componentEdit,
    componentDelete
  },
  data() {
    return {
      users: [],
      user: {},
      page: 1,
      pages: [],
      elementsPerPage: 5,
      rol_usuario: localStorage.getItem("rol_usuario"),

      modalAdd: false,
      modalEdit: false,
      modalDelete: false,
      showModalConfirm: false,

      //Delete
      deleteName: '',
      deleteId: '',

      //Edit
      editName: '',
      editId: '',
      confirmDelete: '',


      //localStorage
      secretWord: localStorage.getItem('secret-word')
    }
  },
  computed: {
    ...mapState(['costea']),
    displayedUsers() {
      return this.paginate(this.users);
    },
    showModalAdd() {
      if (this.modalAdd === true) {
        return 'componentAdd'
      } else {
        return ''
      }
    },
    showModalEdit() {
      if (this.modalEdit === true) {
        return 'componentEdit'
      } else {
        return ''
      }
    }
  },
  methods: {
    toggleModalConfirm(id, name) {
      this.deleteId = id
      this.deleteName = name
      this.showModalConfirm = !this.showModalConfirm;
    },
    showImage(imagen) {
      if (imagen != null) {
        return this.costea.protocol + this.secretWord + '.backend.costea.com.co/' + imagen
      } else {
        return '/img/perfilCostea.png'
      }
    },
    deleteUser() {
      //axios.delete
      // if (this.confirmDelete == "borrar") {
      //   console.log("eliminar objeto")
      //   this.toggleModalConfirm(0, null)
      //   this.confirmDelete = ""
      // } else {
      //   console.log("no es la palabra")
      // }

      if (this.confirmDelete === "borrar" || this.confirmDelete === "BORRAR") {
        // Realizar la solicitud DELETE utilizando Axios
        axios.delete(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}user/${this.deleteId}`)
          .then(response => {
            // Manejar la respuesta exitosa
            console.log(response.data); // Puedes mostrar la respuesta en la consola o realizar alguna acción adicional

            // Redirigir a una página o realizar alguna acción después de eliminar el usuario
            // Ejemplo de redirección a una página específica
            // this.$router.push('/admin/admins');

            this.reloadData(true)
            // Mostrar un mensaje de éxito
            this.$toast.success('Usuario eliminado exitosamente.');
            
          })
          .catch(error => {
            // Manejar el error de la solicitud
            console.error(error);
            this.reloadData(true)

            // Mostrar un mensaje de error
            this.$toast.error('Error al eliminar el usuario.');
          });

        // Restablecer la confirmación de eliminación y cerrar el modal de confirmación
        this.toggleModalConfirm(0, null);
        this.confirmDelete = "";
      } else {
        console.log("no es la palabra");
      }

    },
    getUsers: function () {
      axios
        .get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}users`)
        .then(respuesta => {
          if (respuesta.data.status == false) {
            this.$router.push('/login')
          }
          this.users = respuesta.data;
          this.pages = []
          this.setPages()
        }).catch((error) => {
          if (error.response.status === 401) {
            this.$router.push('/login')
          }
        })
    },
    reloadData(value) {
      if (value === true) {
        this.getUsers()
        value = false
      } else {
        console.log('Ocurrio un error')
      }
    },


    //Show Edit and Delete
    // ModalEdit(){
    //   if(this.modalEdit === false){
    //       this.modalEdit = true

    //   }else{
    //     this.modalEdit = false
    //   }
    // },
    showModalDelete(name, id) {
      if (this.modalDelete === false) {
        this.modalDelete = true
        this.deleteName = name
        this.deleteId = id
      } else {
        this.modalDelete = false
      }
    },


    //Handles
    async openEditModal(id) {
      this.editId = id
      this.modalEdit = true


    },
    handleAddOpenModal(value) {
      this.modalAdd = value
    },
    handleAddCloseModal(value) {
      this.modalAdd = value
    },
    handleEditCloseModal(value) {
      this.modalEdit = value
    },
    handleDeleteCloseModal(value) {
      this.modalDelete = value
    },

    //Paginado
    setPages() {
      let numberOfPages = Math.ceil(this.users.length / this.elementsPerPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(obj) {
      let page = this.page;
      let perPage = this.elementsPerPage;
      let from = (page * perPage) - perPage;
      let to = (page * perPage);
      return obj.slice(from, to);
    },
    getPageNumber() {
      return this.pages.length
    }
  },
  beforeMount() {
    if (localStorage.getItem('token')) {
      if (localStorage.getItem('rol_usuario') === '2') {
        this.$router.push('/')
      } else {
        this.getUsers()
      }
    } else {
      this.$router.push('/login')
    }
  },

}
</script>

<style></style>